import { render, staticRenderFns } from "./saleCustomerInvoice.vue?vue&type=template&id=488dca4a&scoped=true"
import script from "./saleCustomerInvoice.vue?vue&type=script&lang=js"
export * from "./saleCustomerInvoice.vue?vue&type=script&lang=js"
import style0 from "./saleCustomerInvoice.vue?vue&type=style&index=0&id=488dca4a&prod&scoped=true&lang=css"
import style1 from "./saleCustomerInvoice.vue?vue&type=style&index=1&id=488dca4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488dca4a",
  null
  
)

export default component.exports